import { getCookieAuthInfo } from '@/utils'
import { useSyncExternalStore } from 'react'

const getSnapshot = () => {
  try {
    const { darkMode } = getCookieAuthInfo('darkMode')
    const storageTheme = JSON.parse(darkMode || window?.localStorage.getItem('darkMode') || 'null')
    if (storageTheme !== null) return storageTheme
    return window.matchMedia('(prefers-color-scheme: dark)').matches
  } catch {
    return typeof window !== 'undefined' && window.matchMedia ? window.matchMedia('(prefers-color-scheme: dark)').matches : true
  }
}

const subscribe = (callback: () => void) => {
  const media = window.matchMedia('(prefers-color-scheme: dark)')
  media.addEventListener('change', callback)
  return () => media.removeEventListener('change', callback)
}

export const useSystemDark = () => useSyncExternalStore(subscribe, getSnapshot, getSnapshot)
